interface Banner_data {
    imgurl : string;
}

let banner_data: Banner_data[] = [
    {
        imgurl : './img/banner/img0.jpg'
    },
    {
        imgurl : './img/banner/img1.jpg'
    }
]

export default banner_data;